import React from "react";
import { useFormikContext } from "formik";
import { PAYMENT_METHOD_LABEL_MAP } from "utils/constants/payment";
import InheritenceDisplay from "components/InheritenceDisplay";
import { PAYMENT_METHOD_TYPE_ICON_MAP } from "components/PaymentMethodIcons";
import StatusIcon from "components/StatusIcon";
import { STATE_KEYS } from "utils/constants/state";
import { STATUS } from "utils/constants/ui";
import { useMessagesError } from "utils/hooks/editor";

const PaymentMethodTypesSummary = ({ title, methods, name }) => {
  const { setFieldValue } = useFormikContext();

  const error = useMessagesError(STATE_KEYS.SHORT_LINK.PAYMENT_METHOD_TYPES);

  return (
    <InheritenceDisplay
      title={title}
      error={error}
      onRemove={() => {
        setFieldValue(STATE_KEYS.SHORT_LINK.PAYMENT_METHOD_TYPES, []);
      }}
    >
      <ul className="f6 pt2 word-break list ma0 pa0">
        {Array.isArray(methods) && methods.length ? (
          methods.map((method, methodIx) => {
            const TypeIcon = PAYMENT_METHOD_TYPE_ICON_MAP[method];
            return (
              <li key={method} className={methodIx ? "pt1" : "pt0"}>
                <div className="flex flex-row items-center w-100">
                  <div
                    className="flex items-center justify-center"
                    style={{ width: 32, height: 32 }}
                  >
                    {TypeIcon ? <TypeIcon /> : null}
                  </div>
                  <div className="flex flex-row items-center justify-between w-100">
                    <div className="f6 pl2 w-100">
                      {PAYMENT_METHOD_LABEL_MAP[method]}
                    </div>
                  </div>
                </div>
              </li>
            );
          })
        ) : (
          <li className="pt0">
            <div className="flex flex-row justify-between items-center">
              <div className="f6 word-break pr1">Automatic</div>
              <StatusIcon status={STATUS.SUCCESS} size={20} />
            </div>
          </li>
        )}
      </ul>
    </InheritenceDisplay>
  );
};

export default PaymentMethodTypesSummary;
